var addPx = function addPx(pxValue, addValue) {
  var value = Number(pxValue.replace('px', ''));
  return "".concat(value + addValue, "px");
};

export { addPx };
//# sourceMappingURL=utils.js.map
